import { createStyles, CSSObject } from "@mantine/core";

export const useStyles = createStyles(() => ({
  emailWrapper: {
    wordWrap: "break-all" as CSSObject["wordWrap"],
    overflowWrap: "anywhere",
  },
}));
